import { useEffect } from "react";
import { onLocalWrite } from "@/lib/store";
import { syncNow } from "@/lib/sync";
import { useUIStore } from "@/stores/ui";

const INTERVAL_MS = 60_000;
// Batches a burst of edits (e.g. triaging an inbox) into one flush.
const AFTER_WRITE_MS = 800;

/** Keeps Dexie and the API in step while the app shell is mounted. */
export function useSyncLoop() {
	const setSyncing = useUIStore((s) => s.setSyncing);

	useEffect(() => {
		let disposed = false;
		let debounce: ReturnType<typeof setTimeout> | undefined;

		const run = async () => {
			if (disposed || !navigator.onLine) return;
			setSyncing(true);
			try {
				await syncNow();
			} finally {
				if (!disposed) setSyncing(false);
			}
		};
		const soon = () => {
			clearTimeout(debounce);
			debounce = setTimeout(run, AFTER_WRITE_MS);
		};

		void run();
		const timer = setInterval(run, INTERVAL_MS);
		window.addEventListener("online", run);
		const unsubscribe = onLocalWrite(soon);
		return () => {
			disposed = true;
			clearTimeout(debounce);
			clearInterval(timer);
			window.removeEventListener("online", run);
			unsubscribe();
		};
	}, [setSyncing]);
}
